import axios from "./axios";
import { transformRegisterUserData } from '@/transformer/transformRegisterUserData';

export const signIn = async credentials => {
    await axios.get("/sanctum/csrf-cookie");
    await axios.post("/login", credentials);
};

export const googleLogin = async credentials => {
    await axios.get("/sanctum/csrf-cookie");
    await axios.post("/api/auth/google-login", credentials);
};
export const microsoftLogin = async credentials => {
    await axios.get("/sanctum/csrf-cookie");
    await axios.post("/api/auth/microsoft-login", credentials);
};

export const prepareSessionForUserWithNoAccountRequired = async LUDAWCA => {
    const query = `LUDAWCA=${LUDAWCA}`;
    const response = await axios.get(`/api/prepare-session?${query}`);

    return response.data.data;
};

export const myInfo = async (companyId, LUDAWCA) => {
    let query = companyId ? `switch-to=${companyId}&` : "";
    query += LUDAWCA ? `LUDAWCA=${LUDAWCA}` : "";

    const response = await axios.get(`/api/startup-data?${query}`);
    return response.data.data;
};

export const signOut = async () => {
    const response = await axios.post("/logout");
    return response.data;
};

export const signUp = async data => {
    const response = await axios.post("/register", transformRegisterUserData(data));
    return response;
};

export const generateOtp = async () => {
    const response = await axios.get('/api/generate-otp');
    return response;
};

export const verifyOtp = async otp => {
    const response = await axios.post('/api/verify-otp', {
        otp_code: otp
    });
    return response;
};
